import { Component, OnInit } from '@angular/core';

interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-shift-allocation',
  templateUrl: './shift-allocation.component.html',
  styleUrls: ['./shift-allocation.component.scss']
})
export class ShiftAllocationComponent implements OnInit {
  listOfData2: ItemData2[] = [];
  value?: string;
  date = null;
  selectedValue = null;
  checked = true;

  onChange(result: Date): void {
    console.log('onChange: ', result);
  }

  constructor() { }

  ngOnInit(): void {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

}
